module.exports = {
      id: "like-color-usage",
      viewBox: "0 0 25 23",
      url: "img/" + "sprite.svg#like-color-usage",
      toString: function () {
        return this.url;
      }
    }